export default {"src":"/_next/static/media/toggle_24.f8f64186.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};